/* Shto jump: a button or rating line inside our sections that links to "#something" on the page glides there and stops
   with the target's top just under the store's header, not hidden behind it.
   With our landing-page header (sections/shto-lp-header.liquid, pinned with position: sticky) the target stops under it.
   Otherwise Organics Ocean's header (sections/custom-header.liquid, .header-fluid) is in the page flow at the top; past 350px of
   scroll it becomes position: fixed and always visible, so the page below moves up by its height. Where a jump ends is
   worked out for that: the target moves up by the header's height once the header is fixed, and the header then covers
   that much of the screen. Without such a header it is a plain jump. Loaded by every section with a jump link; runs once. */
(function () {
  if (window.ShtoJump) return;
  window.ShtoJump = true;

  // Development rule (Kevin 2026-10-02): a page opens at the top even when its address ends in #shto-... (a link copied
  // from an old version, or one shared with a section's id). The browser would otherwise start at that section. The
  // address itself is never changed.
  if (/^#shto-/.test(location.hash)) {
    var toTop = function () { window.scrollTo({ top: 0, behavior: 'instant' }); };
    toTop();
    if (document.readyState === 'complete') setTimeout(toTop, 0);
    else window.addEventListener('load', function () { toTop(); setTimeout(toTop, 0); }, { once: true });
  }
  var FIXED_FROM = 350; // the header script's threshold

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.shto a[href^="#"]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();

    // Our own pinned landing-page header (shto-lp-header) stays in the flow and covers the top of the screen.
    var ours = document.querySelector('[data-shto-sticky-header]');
    if (ours && !ours.offsetHeight) ours = null;
    var header = ours || document.querySelector('.header-fluid');
    var h = header ? header.offsetHeight : 0;
    var headerInFlow = !ours && header && !header.classList.contains('sticky-nav');
    var y = target.getBoundingClientRect().top + window.scrollY;
    if (headerInFlow) y -= h;          // the header leaves the flow once the page scrolls past FIXED_FROM
    var top = y - h;                   // and then covers the top h pixels of the screen
    if (!ours && top < FIXED_FROM) top = Math.max(0, y + (headerInFlow ? h : 0) - h); // short jumps: the store header is still in the flow
    if (ours) top = Math.max(0, top);

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.round(top), behavior: still ? 'auto' : 'smooth' });
    // Photos loading on the way, or the header changing size as it becomes fixed, can move the target while the page
    // glides. Once it stops, nudge so the target sits right under the header.
    var done = false;
    function settle() {
      if (done) return; done = true;
      window.removeEventListener('scrollend', settle);
      var under = header && (ours || header.classList.contains('sticky-nav')) ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var off = Math.round(target.getBoundingClientRect().top - under);
      if (Math.abs(off) > 1) window.scrollBy({ top: off, behavior: still ? 'auto' : 'smooth' });
    }
    if ('onscrollend' in window) {
      window.addEventListener('scrollend', settle);
      if (Math.abs(window.scrollY - Math.round(top)) < 2) settle(); // nothing to scroll: no scrollend comes
    } else setTimeout(settle, 1500); // browsers without scrollend
    if (target.tabIndex < 0 && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
